import React from 'react'
import R from 'ramda'
import {connect} from 'react-redux'
import {createSelector} from 'reselect'

import EstateCardList from './EstateCardList'
import QuerySummary from './QuerySummary'
import DelayedLoader from './DelayedLoader'
import NoEstateFound from './NoEstateFound'
import LoadingEstates from './LoadingEstates'
import EstateFlippableCard from './EstateFlippableCard'
import StatelessFuncToPureComponent from './StatelessFuncToPureComponent'

import sortedEstateList from '../selectors/sortedEstateList'

import smoothScroll from '../utils/smoothScroll.js'

const QueryResultContainer = ({showEstateList, showLoadingEstates, estateList}) => {
  const renderItem  = estate => {
    return <EstateFlippableCard key={estate.key || estate.id} 
                                id={estate.id}
                                proximityScore={estate.proximityScore}
                                />
  }
  const estateCardList =
    <div>
        <QuerySummary/>
        <EstateCardList>
        {  R.isEmpty(estateList) ? 
            <NoEstateFound/> : 
            <DelayedLoader batchSize={10} 
                            list={estateList} 
                            renderItem={renderItem}
                            /> 
        }
        </EstateCardList>
    </div>
   
  const loadingEstates = <div><LoadingEstates/></div>
    
    
  if(!showEstateList) return null
  
  var searchFormElement = document.getElementById("search-sub-form");
  smoothScroll(searchFormElement.offsetHeight+10);
  
  if (showLoadingEstates)
     return loadingEstates;
  else
     return estateCardList;
}

QueryResultContainer.propTypes = {
  showEstateList: React.PropTypes.bool.isRequired,
  showLoadingEstates: React.PropTypes.bool.isRequired,
  estateList: React.PropTypes.array.isRequired,
}

const mapStateToProps = state => ({
    showEstateList: state.show.estateList,
    showLoadingEstates: state.show.loadingEstates,
    estateList: sortedEstateList(state),
})

export default connect(mapStateToProps)(StatelessFuncToPureComponent(QueryResultContainer))



/** WEBPACK FOOTER **
 ** ./app/components/QueryResultContainer.jsx
 **/